import {Component, Input, OnInit} from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'app-price-info-item',
    templateUrl: './price-info-item.component.html',
    styleUrls: ['./price-info-item.component.css'],
    imports: [TranslateModule]
})
export class PriceInfoItemComponent implements OnInit {
  @Input() price

  constructor() {
  }

  ngOnInit(): void {
  }
}
